import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteUserPermissions } from 'api/admin/userPermissions/deleteUserPermissions'
import { getUIPermission } from 'api/admin/userPermissions/permissions'
import { useWhoamiContextValue } from 'components/Whoami/WhoamiProvider'
import { userPermissionsKeys } from 'queries/admin/userPermissions/keys'

export function useDeleteUserPermissionsMutation() {
  const queryClient = useQueryClient()
  const { hasPermission } = useWhoamiContextValue()
  const permission = getUIPermission(hasPermission)
  return useMutation({
    mutationFn: (request: Parameters<typeof deleteUserPermissions>[0]) =>
      deleteUserPermissions(request, permission || 'permission_admin'),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: userPermissionsKeys.all,
      })
    },
  })
}
